/* eslint-disable no-mixed-operators */
import React, { Component } from 'react';
import { func } from 'prop-types';
import { Button } from '@material-ui/core';
import { DefaultAudioMixController } from 'amazon-chime-sdk-js';

import { withMeetingContext, MeetingContextDeviceControlsProps } from '../../../Scenes/_root/meetingContext';

class TestAudioOutput extends Component {
  constructor(props) {
    super(props);
    this.audioMixController = new DefaultAudioMixController();
    this.frequency = 440;
    this.sinkId = null;
    this.durationSec = 1;
    this.rampSec = 0.1;
    this.maxGainValue = 0.1;
    this.state = {
      isPlaying: false,
    };
    this.deregisterMeetingCallbacks = props.registerMeetingCallbacks('testAudio', {
      onSelectedAudioOutDeviceIdUpdated: this.rebindOnAudioOutChange,
    });
  }

  componentWillUnmount() {
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.deregisterMeetingCallbacks();
  }

  rebindOnAudioOutChange = (newAudioOutDeviceId) => {
    this.audioMixController.bindAudioDevice({ deviceId: newAudioOutDeviceId });
  }

  onClick = () => {
    const { deviceControls } = this.props;
    const { audioOut } = deviceControls.getSelectedDeviceIds();

    this.setState({ isPlaying: true });

    // yanked from Chime sdk
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();

    const gainNode = audioContext.createGain();

    gainNode.gain.value = 0;
    const oscillatorNode = audioContext.createOscillator();

    oscillatorNode.frequency.value = this.frequency;
    oscillatorNode.connect(gainNode);

    const destinationStream = audioContext.createMediaStreamDestination();

    gainNode.connect(destinationStream);

    const { currentTime } = audioContext;
    const startTime = currentTime + 0.1;

    gainNode.gain.linearRampToValueAtTime(0, startTime);
    gainNode.gain.linearRampToValueAtTime(this.maxGainValue, startTime + this.rampSec);
    gainNode.gain.linearRampToValueAtTime(this.maxGainValue, startTime + this.rampSec + this.durationSec);
    gainNode.gain.linearRampToValueAtTime(0, startTime + this.rampSec * 2 + this.durationSec);
    oscillatorNode.start();

    if (audioOut) {
      this.audioMixController.bindAudioDevice({ deviceId: audioOut });
    }
    this.audioMixController.bindAudioElement(new Audio());
    this.audioMixController.bindAudioStream(destinationStream.stream);

    this.timer = window.setTimeout(
      () => this.onTestSoundComplete(audioContext),
      (this.rampSec * 2 + this.durationSec + 1) * 1000
    );
  };

  onTestSoundComplete = (audioContext) => {
    this.setState({ isPlaying: false });
    audioContext.close();
  };

  render() {
    return (
      <Button
        disabled={this.state.isPlaying}
        fullWidth
        onClick={this.onClick}
        type='button'
      >
        Test Sound
      </Button>
    );
  }
}

TestAudioOutput.propTypes = {
  deviceControls: MeetingContextDeviceControlsProps,
  registerMeetingCallbacks: func.isRequired,
};

export default withMeetingContext(['registerMeetingCallbacks', 'deviceControls'])(TestAudioOutput);
